/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ReplicationStateType {
    NotFound = 0,
    Failed = 1,
    Pending = 2,
    Ready = 3,
}
